var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandleCorner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b3afaf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.7 16 9.3-9.3v-1.4l-10.7 10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7 16 6.3-6.3v-1.4l-7.7 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7 16 3.3-3.3v-1.4l-4.7 4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.7 16 .3-.3v-1.4l-1.7 1.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandleCorner);
export default __webpack_public_path__ + "static/media/handle-corner.0fc7142eaa4fce889f035ed9d6006062.svg";
export { ForwardRef as ReactComponent };